import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import isArray from 'lodash/isArray';
import { ElementVisibility } from './types';
import { useElementVisibilityMap } from './useElementVisibilityMap';
export const ElementVisibilityContext = /*#__PURE__*/ React.createContext({
    elementGroups: {
        adoptableBuyer: {
            groupVisibility: ElementVisibility.NotIncluded,
            countOnBar: 0
        },
        adoptableSeller: {
            groupVisibility: ElementVisibility.NotIncluded,
            countOnBar: 0
        }
    },
    deleteDeviation: ElementVisibility.NotIncluded,
    editBackground: ElementVisibility.NotIncluded,
    editDeviation: ElementVisibility.NotIncluded,
    favourite: ElementVisibility.NotIncluded,
    fullscreen: ElementVisibility.NotIncluded,
    report: ElementVisibility.NotIncluded,
    share: ElementVisibility.NotIncluded,
    subscribe: ElementVisibility.NotIncluded,
    comment: ElementVisibility.NotIncluded,
    commissionStatus: ElementVisibility.NotIncluded,
    orderCommission: ElementVisibility.NotIncluded,
    premiumDownload: ElementVisibility.NotIncluded,
    freeDownload: ElementVisibility.NotIncluded,
    addToGroup: ElementVisibility.NotIncluded,
    awardBadge: ElementVisibility.NotIncluded,
    sellDeviation: ElementVisibility.NotIncluded,
    privateCollection: ElementVisibility.NotIncluded,
    meta: {
        hasPrimaryMoreActionsMenu: false,
        hasSecondaryMoreActionsMenu: false
    }
});
export const ElementVisibilityContextProvider = ({ deviation, children })=>{
    const visibilityMap = useElementVisibilityMap(deviation);
    return /*#__PURE__*/ React.createElement(ElementVisibilityContext.Provider, {
        value: visibilityMap
    }, children);
};
ElementVisibilityContextProvider.displayName = 'ElementVisibilityContextProvider';
/**
 * A variant of {@link useElementVisibilityMap} that returns booleans instead of {@link ElementVisibility} values.
 *
 * This assumes you already have an {@link ElementVisibilityContext} in your React tree.
 */ export function useElementVisibilityForArea(visibilityArea) {
    const elementVisibilityMap = useContext(ElementVisibilityContext);
    const mapWithBooleansInstead = mapValues(omit(elementVisibilityMap, [
        'elementGroups',
        'meta'
    ]), (visibility)=>{
        return isArray(visibility) ? visibility.includes(visibilityArea) : visibility === visibilityArea;
    });
    mapWithBooleansInstead.elementGroups = mapValues(elementVisibilityMap.elementGroups, (elementGroup)=>_object_spread_props(_object_spread({}, elementGroup), {
            groupVisibility: elementGroup.groupVisibility === visibilityArea
        }));
    mapWithBooleansInstead.meta = elementVisibilityMap.meta;
    return mapWithBooleansInstead;
}

//# sourceMappingURL=ElementVisibilityContext.js.map